import React, {useState, useRef, useEffect} from "react";
import UploadPhoto from "../Modals/UploadPhoto";
import {colorBorder, colorError, colorInputBorderGrayish} from "../../Constants/theme";
import { Typography,
    Grid,
    FormControlLabel,
    useMediaQuery,
    TextField as RTextField,
    Box,
    Button,
    Theme,
    Select,
    MenuItem,
    makeStyles,
    Container } from "@material-ui/core";

import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import Api from "../../helpers/apiHelpers";
import CameraSVG from "../../Images/camera.svg";

interface Props {
    vetId: number;
    profile: any;
    setLoaded: React.Dispatch<React.SetStateAction<boolean>>
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
}));

const AddLiscenses = ({vetId, profile, setLoaded}: Props) => {
    const classes = useStyle();
    const dispatch = useAppDispatch();
    const [uploadPhotoModalVisibility, setUploadPhotoModalVisibility] = useState(false);
    const [uploadPhotoURL, setUploadPhotoUrl] = useState("");
    const [linkToImage, setLinkToImage] = useState("");
    const imageRef = useRef(null);
    const handleImageLoadError = () => {
        setLinkToImage("");
    };
    const branding = useSelector((state: RootState) => state?.branding);

    // const getURLs = () => {
    // 	Api.getLiscenseUrls(vetId)
    // 		.then((res) => {
    // 			setUploadPhotoUrl(res.uploadUrl);
    // 			return res.uploadUrl;
    // 		});
    // }

    return (
        <div style={{cursor: "pointer"}}>
            <img
                alt="image of vet license"
                ref={imageRef}
                src={CameraSVG}
                onError={handleImageLoadError}
                width="100"
                height="100"
                style={{objectFit: "cover", padding: "10px 2.5px"}}
                onClick={() => {
                    // getURLs();
                    setUploadPhotoModalVisibility(true);
                }}
            />
            <UploadPhoto
                onClose={() => {
                    setUploadPhotoModalVisibility(false);
                }}
                isOpen={uploadPhotoModalVisibility}
                imageUploadURL={uploadPhotoURL}
                onLoad={(val) => {
                    setUploadPhotoModalVisibility(false);
                }}
                setLoaded={setLoaded}
                vetId={vetId}
            />
        </div>
    );
};

export default AddLiscenses;
